<!-- <div *ngIf="(isAuthorized$|async) || true" style="text-align:center" class="container">
    <h1>
        Welcome!
    </h1>
    <div class="container">
        <button (click)="changeLanguage()">{{ _translateService.currentLang === 'en' ? 'FR': 'EN' }}</button><br>

        <router-outlet></router-outlet>

        <a [routerLink]="['home-modular', 'banner'] | customLocalize"
            [queryParams]="{'search': 'test', 'key': 2} | customLocalize" [fragment]="'fragment' | customLocalize">
            {{'routes.home-modular' | translate}}
        </a>
        <br><br>

        <button (click)="navigate()">{{ 'routes.navigate' | translate}}</button>
        <br><br>
        <button (click)="navigateUrl()">{{ 'routes.navigateUrl' | translate}}</button>

        <ng-container *ngIf="(safeDropLocation$|async) || null; let safeDropLocation">
            <p>{{ 'safedropLocation.code' | translate }} : <span id="cd">{{safeDropLocation.cd}}</span></p>
            <p>{{ 'safedropLocation.description' | translate }} : <span id="en_Desc">{{safeDropLocation.desc}}</span>
            </p>
        </ng-container>
    </div>
</div>

// testing -->


 <router-outlet></router-outlet>